/**
 * Standard trend colors. Must match theme.extend.colors in tailwind.config.ts
 * (positive / negative) for use in inline styles (e.g. MUI sx).
 */
export const TREND_POSITIVE = "#5DC54F";
export const TREND_NEGATIVE = "#F04B5B";
export const TREND_PENDING = "#FDB90E";
